<div
	class="obg-m-argentina-reality-check-snackbar-content-wrap"
	test-id="argentina-reality-check-snackbar"
	data-test-id="argentina-reality-check-snackbar"
>
	<div class="obg-m-argentina-reality-check-snackbar-content">
		<a
			*ngIf="spentTimeIcon$ | async as spentTimeIcon"
			[obgRouteLink]="{ url: spentTimeIcon.link.url }"
			[target]="spentTimeIcon.link.target"
		>
			<obg-lazy-image
				*ngIf="spentTimeIcon.logo.url"
				[attr.test-id]="'img_' + spentTimeIcon?.key"
				[src]="spentTimeIcon.logo.url"
				[alt]="spentTimeIcon.logo.altText"
			></obg-lazy-image>
		</a>
		<a
			*ngIf="spentMoneyIcon$ | async as spentMoneyIcon"
			[obgRouteLink]="{ url: spentMoneyIcon.link.url }"
			[target]="spentMoneyIcon.link.target"
		>
			<obg-lazy-image
				*ngIf="spentMoneyIcon.logo.url"
				[attr.test-id]="'img_' + spentMoneyIcon?.key"
				[src]="spentMoneyIcon.logo.url"
				[alt]="spentMoneyIcon.logo.altText"
			></obg-lazy-image>
		</a>
		<div class="message">
			<span>
				{{ "reality-check.message" | translate }}
			</span>
		</div>
	</div>

	<div *ngIf="data.buttons?.length" class="obg-m-argentina-reality-check-snackbar-buttons">
		<ng-container *ngFor="let button of data.buttons">
			<a *ngIf="getButtonCounter(button) | async as counter; else regularButtons" mat-flat-button disabled>
				{{ "reality-check.dismiss-in" | translate }} {{ counter }} {{ "general.seconds" | translate }}
			</a>
			<ng-template #regularButtons>
				<a
					mat-flat-button
					[obgRouteLink]="{ url: button.url }"
					[target]="button.target"
					(click)="onDismiss()"
					color="primary"
					test-id="argentina-reality-check-dismiss-button"
					data-test-id="argentina-reality-check-dismiss-button"
					>{{ button.text }}</a
				>
			</ng-template>
		</ng-container>
	</div>
</div>
